<template>
  <el-container>
    <el-dialog :title="selRow.id == undefined ? '信息新增' : '信息编辑'" :visible="formVisible" @opened="openUser" :before-close="handleClose" append-to-body
               :wrapperClosable="false" :close-on-click-modal="false">
      <el-row style="padding: 30px">
        <el-form ref="form" :model="form" :rules="rules" label-width="90px" >
          <el-col :span="24">
            <el-form-item label="信息标题" prop="noticeName">
              <el-input v-model="form.noticeName" placeholder="请输入信息标题" size="medium" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="作者" prop="noticeAuthor">
              <el-input v-model="form.noticeAuthor" placeholder="请输入作者" size="medium" style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布日期" prop="publishDate">
              <el-date-picker format="" v-model="form.publishDate" type="date" placeholder="选择发布日期"
                              value-format="yyyy-MM-dd" style="width: 100%"/>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="信息类型" prop="noticeType">-->
<!--              <el-select v-model="form.noticeType" placeholder="请选择信息类型" style="width: 100%" size="medium">-->
<!--                <el-option v-for="item in noticeTypeData" :key="item.id" :label="item.name"-->
<!--                           :value="item.value"/>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="24">
            <el-form-item label="信息内容" prop="noticeContent" width="100%">
              <input :ref="inputref" type="file" name="img" accept="image/jpeg,image/jpg,image/png" id="quillInput"  class="quill-img" multiple="multiple" hidden @change="getImgUrl($event)" />
              <quill-editor :id="randomString(3)"
                  v-model="form.noticeContent"
                  ref="approveQuillEditor"
                  :options="approveEditorOption"
                  @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)">
              </quill-editor>
              <el-upload action="#" :accept="attachAcceptType" :key="randomString(3)"
                         class="avatar-uploader"
                         :http-request="onApproveUploadHandler"
                         :show-file-list="false" >
              </el-upload>
            </el-form-item>
            <el-form-item label="列表图片" prop="attachList">
              <el-upload action="/sysAttach/uploadTempAttach/TRAIN"
                         list-type="text" :accept="attachAcceptType"
                         :on-error="attachHandleError" :on-success="attachHandleSuccess"
                         :on-remove="attachHandleRemove" :on-preview="attachHandlePreview"
                         :before-upload="attachBeforeUpload" :before-remove="attachBeforeRemove"
                         :on-exceed="attachHandleExceedOne" :file-list="attachList" :limit="1"
                         :show-file-list=true multiple style="width: 500px">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red"> 上传文件大小不超过10MB，最多上传1个附件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <el-row class="drawer_footer">
        <el-button type="primary" @click="handleAdd" size="medium" :disabled="$store.state.loading">草 稿</el-button>
        <el-button type="primary" @click="handlePublish" size="medium" :disabled="$store.state.loading">发 布</el-button>
        <el-button @click="handleClose" size="medium" :disabled="$store.state.loading">取 消</el-button>
      </el-row>
    </el-dialog>
  </el-container>
</template>

<script>
import {commonAttachMixin} from "../../../../utils/commonAttachMixin";
import {uploadDoctorData} from "@/api/core/doctorBase";

export default {
  name: "ApproveBaseForm",
  mixins: [commonAttachMixin],
  props: ['formVisible', 'selRow', 'submitUrl', 'noticeTypeData'],
  data() {
    return {
      attachAcceptType: '.jpg,.jpeg,.png',
      content: `<p></p><p><br></p><ol><li><strong><em>Or drag/paste an image here.</em></strong></li><li><strong><em>rerew</em></strong></li><li><strong><em>rtrete</em></strong></li><li><strong><em>tytrytr</em></strong></li><li><strong><em>uytu</em></strong></li></ol>`,
      approveEditorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'],     //引用，代码块
              [{'header': 1}, {'header': 2}],        // 标题，键值对的形式；1、2表示字体大小
              [{'list': 'ordered'}, {'list': 'bullet'}],     //列表
              [{'script': 'sub'}, {'script': 'super'}],   // 上下标
              [{'indent': '-1'}, {'indent': '+1'}],     // 缩进
              [{'direction': 'rtl'}],             // 文本方向
              [{'size': ['small', false, 'large', 'huge']}], // 字体大小
              [{'header': [1, 2, 3, 4, 5, 6, false]}],     //几级标题
              [{'color': []}, {'background': []}],     // 字体颜色，字体背景颜色
              [{'font': []}],     //字体
              [{'align': []}],    //对齐方式
              ['clean'],    //清除字体样式
              ['image']    //上传图片
            ],
            handlers: {
              'image': function (value) {
                if (value) { // value === true
                  let dom = document.querySelectorAll('.avatar-uploader input')
                  console.log(dom)
                  dom[dom.length-1].click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      form: {},
      rules: {
        noticeName: [
          {required: true, message: '请输入信息标题', trigger: 'blur'}
        ],
        // noticeType: [
        //   {required: true, message: '请选择信息类别', trigger: 'change'}
        // ],
        noticeContent: [
          {required: true, message: '请输入信息内容', trigger: 'blur'}
        ],
        publishDate:[
          {required: true, message: '请输入发布日期', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    editor() {
      return this.$refs.approveQuillEditor.quill;
    },
  },
  methods: {
    async openUser() {
      this.attachList = []
      this.form = {...this.selRow};
      this.onEditorReady(this.editor)
      if (this.form.id) {
        this.attachList = await this.findAttachListByDataId(this.form.id, 'TRAIN')
      }
    },
    onEditorReady(editor) { // 准备编辑器
    },
    onEditorBlur() {
    }, // 失去焦点事件
    onEditorFocus() {
    }, // 获得焦点事件
    onEditorChange() {
    }, // 内容改变事件
    handleAdd() {
      this.form.noticeStatus = 0;
      this.submit();
    },
    handlePublish() {
      this.form.noticeStatus = 1;
      this.submit();
    },
    async submit() {
      let valid = await this.$refs.form.validate().catch(() => {
      });
      if (!valid) return;
      let {status} = await this.postRequest(this.submitUrl, this.form);
      if (status === 200) {
        this.handleClose();
        this.$emit('refreshList')
      }
    },
    //下边是弹出
    handleClose() {
      this.$refs.form.clearValidate();
      this.$emit('update:formVisible', false)
    },
    handleDragStart(event) {
      this.startExchangeIndex = event.target.getAttribute('id') || event.target.parentNode.getAttribute('id')
    },
    handleDragOver(event) {
      event.preventDefault()
    },
    handleDragEnd() {
      let startTeamIndex = parseInt(this.startExchangeIndex.split('-')[0])
      let endTeamIndex = parseInt(this.endExchangeIndex.split('-')[0])
      let dataList = [...this.attachList]
      if (this.startExchangeIndex < this.endExchangeIndex)
        this.attachList.forEach((data, index) => {//30
          if (index < startTeamIndex)
            dataList[index] = data
          else if (index === startTeamIndex)
            dataList[endTeamIndex] = data
          else if (index > startTeamIndex && index <= endTeamIndex)
            dataList[index - 1] = data
          else
            dataList[index] = data
        })
      else
        this.attachList.forEach((data, index) => {//3   1
          if (index < endTeamIndex)
            dataList[index] = data
          else if (index === endTeamIndex)
            dataList[index] = this.attachList[startTeamIndex]
          else if (index > endTeamIndex && index <= startTeamIndex)
            dataList[index] = this.attachList[index - 1]
          else
            dataList[index] = data
        })
      this.attachList = dataList
    },
    handleDrop(event) {
      this.endExchangeIndex = event.target.getAttribute('id') || event.target.parentNode.getAttribute('id')
    },
    attachHandleExceedOne(files, fileList) {
      this.$message.warning(`只能上传1个附件`)
    },
    attachBeforeRemove(file) {
      if (file.status !== 'success') return;
      return this.$confirm(`确定删除图片 ${file.name}重新上传？`, '提示', {type: 'warning'}).then(_ => {
        if (file.id && file.state && file.state === 1) {
          this.postRequest('/sysAttach/delete', {'attachId': file.id});
        }

      });
    },
    async onApproveUploadHandler(e) {
      let formData = new FormData()
      formData.append('file', e.file)
      this.postRequestFile("/sysAttach/uploadEditorFile/TRAIN",formData).then(res => {
        if (res.status === 200) {
          console.log("图片url++++",res)
          // 获取光标所在位置
          let quill = this.$refs.approveQuillEditor.quill
          let length = quill.getSelection().index
          // 插入图片
          quill.insertEmbed(length, 'image', res.msg)
          // 调整光标到最后
          quill.setSelection(length + 1)
        }
      })
    },
    randomString(len){
      //默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var tempLen = chars.length, tempStr='';
      for(var i=0; i<len; ++i){
        tempStr += chars.charAt(Math.floor(Math.random() * tempLen ));
      }
      return tempStr;
    }
  },
}
</script>

<style scoped>

</style>
